/* eslint-disable import/prefer-default-export */
import useFetch from '@composables/api/useFetch';
import { BagService } from '../services';

export const useBag = () => {
  const service = new BagService();
  return useFetch(service.fetch.bind(service));
};
